import { useEffect, useState } from "react";

const EVENT = "arandia:mobile-menu";

let currentOpen = false;

export const setMobileMenuOpen = (open: boolean) => {
  currentOpen = open;
  window.dispatchEvent(new CustomEvent<boolean>(EVENT, { detail: open }));
};

export const useMobileMenuOpen = () => {
  const [isOpen, setIsOpen] = useState(currentOpen);

  useEffect(() => {
    const handler = (e: Event) => setIsOpen((e as CustomEvent<boolean>).detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  return isOpen;
};
